import api from '../../service/api'

const updPassword = (data) => api.post("/account/password/reset/confirmation", data)

export default updPassword
